import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShopAntifraudLimitsComponent } from './shop-antifraud-limits/shop-antifraud-limits.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'antifraud-limits'
  },
  {
    path: 'antifraud-limits',
    component: ShopAntifraudLimitsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopSettingsRoutingModule {}
